import { bankersRound } from '@bechtel/client-common';
import { Box, Set, SetDirection, SetSpacing, Text } from '@bechtel/gds';
import { MilestoneStatusCode } from '@bechtel/types';
import { t } from '@lingui/macro';
import { FC } from 'react';
import { MilestoneStatusExt, MilestoneStatusExtended } from '../types';
import { MilestoneHoursProps } from './types';

const getHoursLabel = (
  status: MilestoneStatusExt,
  isFitupMilestone?: boolean,
  hasFitupRequest?: boolean,
  isFitupRequired?: boolean
) => {
  if (isFitupMilestone) return t`Fitup Hours`;

  switch (status) {
    case MilestoneStatusCode.REQUESTED:
      return t`Fitup Hours`;
    case MilestoneStatusCode.PLANNED:
    default:
      return t`Hours to Earn`;
    case MilestoneStatusCode.CLAIMED:
      return hasFitupRequest ? t`Hours Until Claim` : t`Hours Claimed`;
    case MilestoneStatusCode.REJECTED:
      return isFitupRequired ? t`Hours Rejected` : t`Fitup Hours`;
    case MilestoneStatusCode.APPROVED:
      return hasFitupRequest ? t`Hours Until Approve` : t`Hours Approved`;
    case MilestoneStatusExtended.BLOCKED:
      return t`Hours Blocked`;
  }
};

export const MilestoneHours: FC<MilestoneHoursProps> = ({
  hours,
  status,
  isFitupMilestone,
  hasFitupRequest,
  isFitupRequired,
}) => {
  return (
    <Box flexDirection={{ sm: 'column' }} py={{ sm: '500' }}>
      <Set
        style={{ whiteSpace: 'nowrap' }}
        spacing={SetSpacing.COMPACT}
        direction={SetDirection.COL}
        alignItems={'center'}
      >
        <Text size="800" color="grey.1000">
          {isFitupMilestone ? '-' : bankersRound(hours, 0)}
        </Text>

        <Text size="300" color="grey.600">
          {getHoursLabel(status, isFitupMilestone, hasFitupRequest, isFitupRequired)}
        </Text>
      </Set>
    </Box>
  );
};
